import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      borderRadius: palette.borderRadius.default,
      transition: '0.3s ease',
      fontWeight: 600,
      fontSize: '0.875rem',
      maxHeight: '44px',
      padding: '10px',
      cursor: 'pointer'
    },
    mobile: {
      backgroundColor: palette.background.box,
      border: 'none',
      position: 'relative'
    },
    active: {
      backgroundColor: palette.background.underBox
    },
    green: {
      border: `2px solid ${palette.common.green}`
    },
    desktop: {
      color: palette.common.black,
      boxShadow: palette.shadows.boxShadow,
      border: 'none',
      backgroundColor: palette.common.green,
      overflowX: 'hidden',
      '&:hover': {
        transform: 'scale(1.1)',
        overflowX: 'visible'
      }
    },
    articles: {
      fontWeight: 700,
      fontSize: '1rem',
      marginRight: '5px'
    },
    articlesMobile: {
      position: 'absolute',
      bottom: '-2px',
      right: '-2px',
      boxShadow: palette.shadows.boxShadow,
      backgroundColor: palette.common.green,
      padding: '2px 5px 2px 5px',
      borderRadius: palette.borderRadius.default
    },
    desc: {
      position: 'absolute',
      width: 'max-content',
      right: 'calc(100% + 15px)',
      top: '14px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
